import React from 'react'

const MainFooter = () => {
  return (
    <div className='d-none'>MainFooter</div>
  )
}

export default MainFooter